import { FormatPhonePipe } from '../../../../../../modules/mapfre-design-library/src/lib/_helpers/_pipes/format-phone.pipe';
import { CustomDateFormatPipe } from '../../../../../../_helpers/_pipes/custom-date-format.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CustomDateFormatPipe, FormatPhonePipe],
  selector: 'app-bn-imp-notice',
  templateUrl: './bn-imp-notice.component.html',
  styleUrls: ['./bn-imp-notice.component.scss']
})
export class BnImpNoticeComponent implements OnInit {
  hideAlert: boolean;
  agentPhoneNumber: string;
  agentName: string;
  @Input() isPaymentFAils: boolean;
  @Input() isInvalidRouting: boolean;
  @Input() policy: any;
  isAutoPay: boolean;
  @Input()  autoPayForce: boolean;
  paymentMessage: boolean;
  @Input() deductionDay: string;
  paymentInfo: string;
  isAcmic: boolean;


  constructor( private acmicService: AcmicService) { 
    this.hideAlert = false;
    this.isPaymentFAils = false;
    this.isInvalidRouting = false;
  }
  onClose() {
    this.hideAlert = true;
  }
  
  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.agentPhoneNumber = this.policy?.agent?.agentISCPhone && this.policy?.agent?.agentISCPhone?.number
                              ? this.policy?.agent?.agentISCPhone?.number
                              : this.policy?.agent?.agentPhone?.number
    this.agentPhoneNumber = this.agentPhoneNumber?.toString().replace(/\D+/g, '');
    this.agentName = this.policy?.agent?.agentName;
    
    
    this.paymentInfo =
      `Payments will be applied to any prior remaining term balance first.
       The current amount due and any prior balances are shown on the dashboard under “Current Amt Min Due”.`;
  }

}


